import React from 'react';
type EyebrowProps = {
  children: React.ReactNode;
  onLight?: boolean;
  className?: string;
};
export function Eyebrow({
  children,
  onLight = false,
  className = ''
}: EyebrowProps) {
  return <p className={`text-xs font-bold uppercase tracking-[0.2em] sm:text-sm ${onLight ? 'text-gold-dark' : 'text-gold'} ${className}`} data-id="element-283" data-mp="2j08g6tzgfsxv">
      {children}
    </p>;
}